import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { SeatGripBar, SeatStudent, seatPinBubbleSx } from "./Seat";
import { tileScaleFromCardWidth } from "./seatLayout";
import { tileContentHeightPxFromScale } from "@/stores/v2/classroomLayoutStore";

interface Props {
	student: SeatStudent | null;
	cardWidth: number;
	card?: JSX.Element;
	tileScaleClassNames?: string;
}

export function SeatDragOverlay({ student, cardWidth, card, tileScaleClassNames }: Props): JSX.Element | null {
	if (!student) return null;

	const contentHeightPx = tileContentHeightPxFromScale(tileScaleFromCardWidth(cardWidth));
	const tileSizingStyle: React.CSSProperties = {
		["--tile-content-height-px" as string]: `${contentHeightPx}px`,
	};
	// dnd-kit sizes the overlay wrapper to the dragged seat's exact measured rect
	// (width: rect.width, height: rect.height). Filling 100% of that wrapper — rather
	// than recomputing a min-height — guarantees the dragged card and its inner content
	// (e.g. the "No activity detected" panel) render at the same height as the seat.
	return (
		<Box
			className={tileScaleClassNames}
			width="100%"
			height="100%"
			borderRadius="md"
			bg="white"
			boxShadow="2xl"
			// Matches the seat: visible so the dragged tile keeps its overhanging pin bubble.
			overflow="visible"
			cursor="grabbing"
			display="flex"
			flexDirection="column"
			style={tileSizingStyle}
		>
			<SeatGripBar />
			{card ? (
				<Box
					width="100%"
					flex="1 1 auto"
					minH={0}
					display="flex"
					flexDirection="column"
					pointerEvents="none"
					sx={{
						".StudentTile": {
							width: "100%",
							height: "100%",
							boxShadow: "none",
							margin: 0,
						},
						".Pin_button.release_claim_button": { display: "none" },
						...seatPinBubbleSx(true),
					}}
				>
					{card}
				</Box>
			) : (
				<Flex flex="1 1 auto" align="center" justify="center" px="8px">
					<Text fontWeight="600" noOfLines={1}>
						{student.firstName} {student.lastName}
					</Text>
				</Flex>
			)}
		</Box>
	);
}
